<template>
    <div class="p-3">
        <h3>Indikator Pelayanan</h3>
        <hr>

        <div class="row mt-3">
            <h4 class="mb-3">Pencarian Data</h4>

            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="year" class="col-sm-4 col-form-label text-end">Tahun</label>
                    <div class="col-sm-8">
                        <v-select v-model="year" :clearable="false" :multiple="false" :options="data_year" label="name"
                            name="year" id="year" placeholder="Pilih Tahun" :single="true" @input="setYear($event)" />
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="mb-3">
                    <div class="col-sm-8 text-end">
                        <button class="btn btn-primary" @click="getPel"><i class="fa fa-search"></i>
                            Cari</button>
                    </div>

                </div>
            </div>

        </div>
        <hr />

        <div class="card mb-3">
            <div class="card-header text-white bg-primary">Data Indikator Pelayanan</div>
            <div class="card-body">
                <div id="table">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Bulan</th>
                                <th>BOR</th>
                                <th>LOS</th>
                                <th>BTO</th>
                                <th>TOI</th>
                                <th>NTR</th>
                                <th>GDR</th>
                                <th>Rata-rata Kunjungan</th>
                            </tr>

                        </thead>
                        <tbody v-for="(item, index) in data_pel" :key="index">
                            <tr>
                                <td style="text-align: center;">
                                    {{ item.bulan }}
                                </td>
                                <td style="text-align: center;">
                                    <template v-if="jumlahHariPerawatan > 0 && pembagiBOR > 0">
                                        {{ Math.ceil((jumlahHariPerawatan / pembagiBOR) * 100) }} %
                                    </template>
                                    <template v-else>
                                        0 %
                                    </template>
                                </td>
                                <td style="text-align: center;">
                                    <template v-if="jumlahHariPerawatan > 0 && item.jumlahPasienKeluar > 0">
                                        {{ Math.ceil((jumlahHariPerawatan / item.jumlahPasienKeluar)) }} Hari
                                    </template>
                                    <template v-else>
                                        0 Hari
                                    </template>
                                </td>
                                <td style="text-align: center;">
                                    <template v-if="jumlahHariPerawatan > 0 && item.jumlahTempatTidur > 0">
                                        {{ Math.ceil((jumlahHariPerawatan / item.jumlahTempatTidur)) }} Hari
                                    </template>
                                    <template v-else>
                                        0 Hari
                                    </template>
                                </td>
                                <td style="text-align: center;">
                                    <template
                                        v-if="jumlahHariPerawatan > 0 && item.jumlahPasienKeluar > 0 && item.jumlahTempatTidur > 0">
                                        {{ Math.ceil((item.jumlahTempatTidur * jumlahPeriode - jumlahHariPerawatan) /
                            item.jumlahPasienKeluar) }} Hari
                                    </template>
                                    <template v-else>
                                        0 Hari
                                    </template>
                                </td>
                                <td style="text-align: center;">

                                    <template
                                        v-if="item.jumlahPasienMeninggalLebihPatdelapan > 0 && item.jumlahPasienKeluar > 0">
                                        {{ Math.ceil((item.jumlahPasienMeninggalLebihPatdelapan /
                            item.jumlahPasienKeluar)) }}
                                    </template>
                                    <template v-else>
                                        0
                                    </template>
                                </td>
                                <td style="text-align: center;">
                                    <template v-if="item.jumlahPasienMeninggal > 0 && item.jumlahPasienKeluar > 0">
                                        {{ Math.ceil((item.jumlahPasienMeninggal /
                            item.jumlahPasienKeluar)) }}
                                    </template>
                                    <template v-else>
                                        0
                                    </template>
                                </td>
                                <td style="text-align: center;">
                                    0
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
    components: {
        'v-select': vSelect
    },
    data() {
        return {
            year: new Date().getFullYear(),
            pembagiBOR: 0,
            jumlahHariPerawatan: 0,
            data_year: [],
            data_pel: [],


        }
    },
    created() {
    },
    async mounted() {
        await Promise.all([this.getYear(), this.getPel()]);
    },
    methods: {
        setYear(value) {
            this.year = value.id;
        },
        getPel() {
            const uri = `/api/external-pelayanan/get-pel?year=${this.year}`

            this.axios.get(uri).then(response => {
                // console.log(status);
                console.log(response.data.data.data);

                if (status == 'success') {
                    this.pembagiBOR = response.data.pembagiBOR;
                    this.jumlahHariPerawatan = response.data.jumlahHariPerawatan;
                    this.data_pel = response.data.data.data
                    this.data_pel = { ...this.data_pel }
                }
            });

        },
        async getYear() {
            const today = new Date();
            this.year = today.getFullYear();
            try {
                const response = await axios.get(`/api/external-pelayanan/get-year`);
                this.data_year = response.data ?? []
            } catch (error) {
                console.error('Error fetching options:', error);
            }
        },

    }
}
</script>
